import React from "react";
import { capitalize } from "../../utils/textFunctions";
import { ExtensionURLs } from "../../routes/NewSearchRecords/SearchRecordTable/GoldenRecordExclusion/Utils";
const Address = ({ data, summary: isSummary, className, type }) => {
  if (isSummary && data.length === 0) {
    return <div>Address: [Empty]</div>;
  }
  if (isSummary) {
    const finalData = data?.filter(
      (addr) =>
        !(Object.keys(addr).length === 1 && addr.hasOwnProperty("extension")),
    );

    const primaryAddress = finalData?.find((addr) =>
      addr?.extension?.some(
        (ext) =>
          ext.url === ExtensionURLs.attrCode &&
          ext.valueString === "PERPRIMERRES",
      ),
    );

    const mailingAddress = finalData?.find((addr) =>
      addr?.extension?.some(
        (ext) =>
          ext.url === ExtensionURLs.attrCode &&
          ext.valueString === "PERMAILADDR",
      ),
    );

    // Display order of priority: Primary > Mailing > First available in list
    const displayAddress = primaryAddress || mailingAddress || finalData?.[0];

    const sourceCode = displayAddress?.extension?.find(
      (ext) => ext?.url === ExtensionURLs.sourceCode,
    )?.valueString;
    const use = displayAddress?.use;
    return (
      <div>
        {displayAddress?.line ? (
          <div>
            Address: {displayAddress?.line?.join("\n")}{" "}
            {sourceCode ? "[" + sourceCode + "]" : ""}{" "}
            {use ? "[" + capitalize(use) + "]" : ""}
          </div>
        ) : null}
      </div>
    );
  }

  if (!isSummary && data.length === 0) {
    return (
      <section>
        <h3>Addresses</h3>
        <div>
          <h4>Empty</h4>
        </div>
      </section>
    );
  }

  return (
    <section>
      <h3>
        {type === "birthplaceAddress" ? "Birth Place Address" : "Addresses"}
      </h3>
      <div className={className}>
        <div>
          <h4>Address Line</h4>
        </div>
        <div>
          <h4>City</h4>
        </div>
        <div>
          <h4>State</h4>
        </div>
        <div>
          <h4>Postal Code</h4>
        </div>
        <div>
          <h4>Use</h4>
        </div>
      </div>

      {data.map((address, index) => {
        return (
          <div key={index} className={className}>
            <div>
              {address.line
                ? address.line.map((addressLine, lKey) => {
                    return <div key={lKey}>{addressLine}</div>;
                  })
                : "NA"}
            </div>
            <div>
              <div>{address.city ? address.city : "NA"}</div>
            </div>
            <div>
              <div>{address.state ? address.state : "NA"}</div>
            </div>
            <div>
              <div>{address.postalCode ? address.postalCode : "NA"}</div>
            </div>
            <div>
              <div>{address.use ? address.use : "NA"}</div>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default Address;
